import { enUS, es } from 'date-fns/locale';

export const getLocale = (languageCode: string) => {
  switch (languageCode) {
    case 'es':
      return es;
    case 'en':
    default:
      return enUS;
  }
};
